import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteReportApi } from '@/api/reportApi'

export const useDeleteReport = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteReportApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['myReports'] })
    }
  })
}
